import styled, { css } from 'styled-components';
import { CODE_FONT_FAMILY } from '@stylesheets/font';

export const CodeInputRow = styled.div`
  display: flex;
  justify-content: center;

  ${({ theme }) => css`
    gap: ${theme.spacing.level3};
    margin: ${theme.spacing.level4} 0;
  `}

  @media (max-width: 400px) {
    gap: 6px;
  }
`;

export const DigitBox = styled.input`
  ${({ theme }) => css`
    width: 48px;
    height: 56px;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    font-family: ${CODE_FONT_FAMILY};
    color: ${theme.colors.onSurface};
    background: ${theme.colors.surfaceContainerHigh};
    border: 2px solid ${theme.colors.outline};
    border-radius: ${theme.borderRadius.small};
    caret-color: ${theme.colors.primary};
    transition: border-color 0.2s;

    &:focus {
      outline: none;
      border-color: ${theme.colors.primary};
    }
  `}

  @media (max-width: 400px) {
    width: 40px;
    height: 48px;
    font-size: 20px;
  }
`;

export const ResendRow = styled.div`
  ${({ theme }) => css`
    text-align: center;
    margin-top: ${theme.spacing.level5};
    font-size: ${theme.font.bodySmall.fontSize};
    color: ${theme.colors.onSurfaceVariant};
  `}
`;

export const ResendLink = styled.button`
  ${({ theme }) => css`
    background: none;
    border: none;
    color: ${theme.colors.primary};
    font-weight: 600;
    cursor: pointer;
    font-size: inherit;
    padding: 0;

    &:hover {
      text-decoration: underline;
    }

    &:disabled {
      color: ${theme.colors.onSurfaceVariant};
      cursor: not-allowed;
      text-decoration: none;
    }
  `}
`;
